/**
 * @hidden
 */
export var useCustomComponent = function (comp) {
    /* if(React.isValidElement<P>(comp)) {
        return [comp.type, comp.props];
    } */
    return [comp, {}];
};
